import { render, staticRenderFns } from "./AstmDeviceActions.vue?vue&type=template&id=7480c2bf&scoped=true"
import script from "./AstmDeviceActions.vue?vue&type=script&lang=js"
export * from "./AstmDeviceActions.vue?vue&type=script&lang=js"
import style0 from "./AstmDeviceActions.vue?vue&type=style&index=0&id=7480c2bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7480c2bf",
  null
  
)

export default component.exports